export default __webpack_public_path__ + "static/media/homepage-hero.014b2228.jpg";